/* eslint-disable @typescript-eslint/naming-convention */
export interface ClassRequirementDto {
  ClassRequirementID: string;
  RequirementID: string | null;
  ClassCodeID: string | null;
  TradeClassID: string | null;
  ReqName: string;
  CompanyID: string | null;
  VPCompanyID: number | null;
  Minimum: number;
  bOptional: boolean;
  bActive: boolean;
  RequirementTypeID: string | null;
  ReqTypeName: string;
  ComparisonType: string;
  DaysQTY: number | null;
  Group: number | null;

  /** Client side only */
  isDirty: boolean;
  /** Client side only */
  isInvalid: boolean;
}
